import { Axios } from "services/axios";

export const featuresApi = {
  getFeaturesByCategory: async (categoryId) => {
    try {
      console.log("category id in features api : ", categoryId);
      if (!categoryId) {
        console.log("category not present in features api")
        console.warn('Category ID is required but not provided');
        return [];
      }

      const response = await Axios.fetch(`/shop/features/category/${categoryId}`);
      console.log("response in features api file : ", response);

      if (!response || !response.data) {
        console.warn('Invalid response structure from features API');
        return [];
      }

      const features = response.data.data || response.data || [];
      
      if (!Array.isArray(features)) {
        console.warn('Features data is not an array, converting:', features);
        return [features]; // Convert to array if it's a single object
      }

      return features;
    } catch (error) {
      console.error('Error fetching features:', error);
      
      // Return empty array instead of throwing to prevent UI crashes
      return [];
    }
  },

  getAdditionalFeaturesByCategory: async (categoryId) => {
    try {
      if (!categoryId) {
        console.warn('Category ID is required but not provided');
        return [];
      }

      const response = await Axios.fetch(`/shop/additionalFeaturesByCategory/${categoryId}`);
      
      if (!response || !response.data) {
        console.warn('Invalid response structure from additional features API');
        return [];
      }

      const additionalFeatures = response.data.data || response.data || [];
      
      if (!Array.isArray(additionalFeatures)) {
        console.warn('Additional features data is not an array, converting:', additionalFeatures);
        return [additionalFeatures]; // Convert to array if it's a single object
      }

      return additionalFeatures;
    } catch (error) {
      console.error('Error fetching additional features:', error);
      
      // Return empty array instead of throwing to prevent UI crashes
      return [];
    }
  },

  getFeaturesForMultipleCategories: async (categoryIds) => {
    try {
      if (!categoryIds || !Array.isArray(categoryIds) || categoryIds.length === 0) {
        console.warn('Category IDs array is required but not provided');
        return {};
      }

      const response = await Axios.post('/shop/features/multiple-categories', {
        categoryIds: categoryIds.map(id => String(id))
      });
      
      if (!response || !response.data) {
        console.warn('Invalid response structure from multiple categories features API');
        return {};
      }

      const featuresData = response.data.data || response.data || {};
      
      return featuresData;
    } catch (error) {
      console.error('Error fetching features for multiple categories:', error);
      
      // Return empty object instead of throwing to prevent UI crashes
      return {};
    }
  }
};
